import { Translator } from '@itarget/shared'

export const useTranslation = () => ({
  adherence: Translator({ transRef: 'translation.Quero participar' }).props
    .children,
  active: Translator({ transRef: 'translation.Ativo' }).props.children,
  expired: Translator({ transRef: 'translation.Encerrada' }).props.children,
  viewDetails: Translator({ transRef: 'translation.Ver detalhes da campanha' })
    .props.children,
  adherenceAt: Translator({
    transRef: 'translation.Você aderiu à esta campanha em %s',
  }).props.children,
})
